import type { PlayerProfileResponse } from '../../../../../services/player/playerProfile'

/**
 * "First Last" for a player, falling back to the API's `full_name`, then `''`
 * (the player has not loaded, or has no name on file).
 */
export const formatPlayerName = (
  player: PlayerProfileResponse | null | undefined
): string => {
  if (!player) {
    return ''
  }
  const joined = [player.name_first, player.name_last]
    .map((part) => (part ?? '').trim())
    .filter(Boolean)
    .join(' ')
  return joined || (player.full_name ?? '').trim()
}
